import { ArrowRight, LifeBuoy } from "lucide-react"
import { SUPPORT_LINK } from "../../constants"
import If from "../if"
import NavigationBadged from "../navigation-badge"

interface Props {
  isFull: boolean
  isDesktop?: boolean
  className?: string
}

const Support: React.FC<Props> = ({ isFull, isDesktop, className = "" }) => {
  return (
    <div
      className={`p-2 pb-4 text-gray-300 whitespace-nowrap overflow-hidden ${className}`}
    >
      {isFull && (
        <NavigationBadged className={`${isDesktop && isFull ? "-mx-2" : ""}`} />
      )}
      <div className={isFull ? "pt-3" : ""}>
        <If
          condition={isFull}
          then={
            <>
              <p className="pb-4 text-sm text-gray-400 uppercase">
                Other resources
              </p>
              <a
                href={SUPPORT_LINK}
                className="flex-shrink-0 w-full group cursor-pointer flex items-center text-sm text-white"
                target="_blank"
                rel="noreferrer"
              >
                Help Articles
                <ArrowRight
                  size={20}
                  className="text-white"
                  aria-hidden="true"
                />
              </a>
            </>
          }
          else={
            <a
              href={SUPPORT_LINK}
              target="_blank"
              rel="noreferrer"
              title="Help Articles"
              className="flex items-center justify-center px-2 py-2 rounded-md text-white/[.6] hover:bg-white/[.1] hover:text-white transition-colors cursor-pointer"
            >
              <span className="sr-only">Help Articles</span>
              <LifeBuoy size={20} aria-hidden="true" />
            </a>
          }
        />
      </div>
    </div>
  )
}

export default Support
